import React, { useRef } from 'react';

function Partners({ language = 'en' }) {
  const carouselRef = useRef(null);

  const partners = [
    'Harrison logo REV.png',
    // 'hbc.png',
    'الراجحي.png',
    'الشواف.png',
    'الهيئة السعودية.png',
    'امام.png',
    'انا.png',
    'براكو.png',
    'بهيم.png',
    'بي.png',
    'تداول.png',
    'تكنيكال.png',
    'جن.png',
    'حكلي.png',
    'رفر.png',
    'زيد.png',
    'سعود.png',
    'سليمان الحبيب.png',
    'سم.png',
    'سيسكو.png',
    'عربي.png',
    'عين.png',
    'فورس.png',
    'ك.png',
    'كوداك.png',
    'مايند.png',
    'وزارة الاسكان.png',
    'وج.png',
    'وزارة الحرس الوطني.png',
    'وزارة العدل.png'
  ];

  const scrollLeft = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: -300, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: 300, behavior: 'smooth' });
    }
  };

  return (
    <section className="partners-section" id="partners">
      <h2 className="partners-title">
        {language === 'ar' ? 'شركاؤنا في ' : 'OUR '}
        <span>{language === 'ar' ? 'النجاح' : 'PARTNERS'}</span>
        {language === 'en' && ' IN SUCCESS'}
      </h2>

      <p className="partners-subtitle">
        {language === 'ar' 
          ? 'نفخر بشراكاتنا الاستراتيجية التي تعزز مشاريعنا بالجودة والموثوقية ورؤية مشتركة لمستقبل المملكة'
          : 'We proudly collaborate with strategic partners who empower our projects with quality, reliability, and shared vision for Saudi Arabia\'s future.'
        }
      </p>

      <div className="partners-carousel-wrapper">
        <button className="carousel-btn prev" onClick={scrollLeft} aria-label="Previous partners">
          &#10094;
        </button>

        <div className="partners-carousel" ref={carouselRef}>
          {partners.map((partner, index) => (
            <div key={index} className="partner-card">
              <img src={`/img/${partner}`} alt={`Partner ${index + 1}`} />
            </div>
          ))}
        </div>

        <button className="carousel-btn next" onClick={scrollRight} aria-label="Next partners">
          &#10095;
        </button>
      </div>

      <p className="drag-hint">
        {language === 'ar' 
          ? 'اسحب شعارات الشركاء يميناً ويساراً أو استخدم الأسهم للتنقل'
          : 'Drag logos left or right, or use arrows to explore our partners.'
        }
      </p>
    </section>
  );
}

export default Partners;